import React, { useEffect, useState, useCallback } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Button, Modal, InputGroup, Form, FormGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { isValidPasswordNew } from '../../helpers/regex';
import _ from 'lodash';

import RoundCloseButton from "../../images/round-close-button.png";
import EyeOpen from "../../images/eye-open.png";
import EyeClose from "../../images/eye-close.png";

type Props = {
  show: boolean;
  onToggle: Function;
  titleModal: string;
  errorMsg: string;
  hasPassword: boolean;
  submitPassword: Function;
  forgotPassword: any;
  passwordPayload: any;
};

const ModalChangePasswordV4 = (props: Props) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [retypePassword, setRetypePassword] = useState('');

  const [newPassEye, setNewPassEye] = useState(false);
  const [oldPassEye, setOldPassEye] = useState(false);
  const [confirmPassEye, setConfirmPassEye] = useState(false);
  const [newPassType, setNewPassType] = useState("password");
  const [oldPassType, setOldPassType] = useState("password");
  const [confirmPassType, setConfirmPassType] = useState("password");
  const [newPassOnFocus, setNewPassOnFocus] = useState(false);
  const [oldPassOnFocus, setOldPassOnFocus] = useState(false);
  const [confirmPassOnFocus, setConfirmPassOnFocus] = useState(false);
  const [newPassOnPlaceHolder, setNewPassOnPlaceHolder] = useState("New Password");
  const [oldPassOnPlaceHolder, setOldPassOnPlaceHolder] = useState("Old Password");
  const [confirmPassPlaceHolder, setConfirmPassPlaceHolder] = useState("Confirm New Password");

  const onChangeOldPassword = (e: any) => setOldPassword(e.target.value);
  const onChangeNewPassword = (e: any) => {
    setNewPassword(e.target.value)
    debounceFn(e.target.value)
  };
  const onChangeRetypePassword = (e: any) => setRetypePassword(e.target.value);

  const handleChangeNewPassword = (value) => {
    const error: any = {};
    if (!isValidPasswordNew(value)) {
      error['_newPassword'] =
        error['_newPassword'] !== undefined
          ? [
            ...error._newPassword,
            'Your password at least contain 8 characters include (. ! -) and combine with capital letter or numeric.',
          ]
          : [
            'Your password at least contain 8 characters include (. ! -) and combine with capital letter or numeric.',
          ];

      if (Object.keys(error).length) {
        setErrors(error);
      }
    } else {
      error['_newPassword'] = [""]
      setErrors(error);
    }
  }

  const debounceFn = useCallback(_.debounce(handleChangeNewPassword, 1000), []);

  const [errors, setErrors] = useState<any>({});

  const validatePassword = () => {
    const error: any = {};
    if (oldPassword === '') {
      error['_oldPassword'] =
        error['_oldPassword'] !== undefined
          ? [...error._oldPassword, 'Please insert old password.']
          : ['Please insert old password.'];
    }

    if (newPassword === '') {
      error['_newPassword'] =
        error['_newPassword'] !== undefined
          ? [...error._newPassword, 'Please insert new password.']
          : ['Please insert new password.'];
    }
    if (retypePassword === '') {
      error['_retypePassword'] =
        error['_retypePassword'] !== undefined
          ? [...error._retypePassword, 'Please insert retype password.']
          : ['Please insert retype password.'];
    }
    if (!isValidPasswordNew(newPassword)) {
      error['_newPassword'] =
        error['_newPassword'] !== undefined
          ? [
            ...error._newPassword,
            'Your password at least contain 8 characters include (. ! -) and combine with capital letter or numeric.',
          ]
          : [
            'Your password at least contain 8 characters include (. ! -) and combine with capital letter or numeric.',
          ];
    }
    if (retypePassword !== newPassword) {
      error['_retypePassword'] =
        error['_retypePassword'] !== undefined
          ? [
            ...error._retypePassword,
            'Retype password is not same with your password.',
          ]
          : ['Retype password is not same with your password.'];
    }
    if (Object.keys(error).length) {
      setErrors(error);
    }
    return error;
  };

  const submitChangePassword = async (e) => {
    e.preventDefault();
    const valid = await validatePassword();
    if (Object.keys(valid).length === 0) {
      const payload = {
        new_password: newPassword,
        old_password: oldPassword,
      };
      props.submitPassword(payload);
    }
  };

  useEffect(() => {
    if (newPassEye) {
      setNewPassType("text")
    } else {
      setNewPassType("password")
    }
  }, [newPassEye])

  useEffect(() => {
    if (oldPassEye) {
      setOldPassType("text")
    } else {
      setOldPassType("password")
    }
  }, [oldPassEye])

  useEffect(() => {
    if (confirmPassEye) {
      setConfirmPassType("text")
    } else {
      setConfirmPassType("password")
    }
  }, [confirmPassEye])

  useEffect(() => {
    setOldPassword(props.passwordPayload?.old_password ?? "")
    setNewPassword(props.passwordPayload?.new_password ?? "")
    setRetypePassword(props.passwordPayload?.new_password ?? "")
  }, [props.passwordPayload])
  return (
    <Modal
      id="modal-password-v4"
      show={props.show}
      onHide={() => props.onToggle()}
      centered
    >
      <Modal.Body>
        <KickImage onClick={() => props.onToggle()} className='close-icon' src={RoundCloseButton} alt="..." />
        <p className='title'>{props.titleModal}</p>
        {
          props.hasPassword === false ?
            <div className="no-password-wrapper">
              <div style={{ padding: '1rem', textAlign: 'center' }}>
                <p>
                  You do not have inserted any password yet. Please click link below
                  to create your password:{' '}
                </p>
                <a
                  href={'/forgot-password'}
                  className="text-black d-block"
                  style={{ color: '#4990e2' }}
                >
                  Forgot Password
                </a>
              </div>
            </div>
            :
            <>
              <Form onSubmit={submitChangePassword}>
                <FormGroup className="password-input">
                  {<p className={`sub-title ${(oldPassOnFocus || oldPassword) ? "show" : ""}`}>Old Password</p>}
                  <InputGroup>
                    <input
                      type={oldPassType}
                      name="_oldPassword"
                      value={oldPassword}
                      onChange={onChangeOldPassword}
                      placeholder={oldPassOnPlaceHolder}
                      onFocus={() => {
                        setOldPassOnFocus(true)
                        setOldPassOnPlaceHolder("")
                      }}
                      onBlur={() => {
                        setOldPassOnFocus(false)
                        setOldPassOnPlaceHolder("Old Password")
                      }}
                    />
                    <KickImage onClick={() => {
                      setOldPassEye(!oldPassEye)
                    }} src={oldPassEye ? EyeOpen : EyeClose} />
                  </InputGroup>
                  <p className="invalid-password">
                    {errors.hasOwnProperty('_oldPassword')
                      ? errors._oldPassword[0]
                      : null}
                  </p>
                </FormGroup>

                <FormGroup className="password-input">
                  {<p className={`sub-title ${(newPassOnFocus || newPassword) ? "show" : ""}`}>New Password</p>}
                  <InputGroup>
                    <input
                      type={newPassType}
                      name="_newPassword"
                      value={newPassword}
                      onChange={onChangeNewPassword}
                      placeholder={newPassOnPlaceHolder}
                      onFocus={() => {
                        setNewPassOnFocus(true)
                        setNewPassOnPlaceHolder("")
                      }}
                      onBlur={() => {
                        setNewPassOnFocus(false)
                        setNewPassOnPlaceHolder("New Password")
                      }}
                    />
                    <KickImage onClick={() => {
                      setNewPassEye(!newPassEye)
                    }} src={newPassEye ? EyeOpen : EyeClose} />
                  </InputGroup>
                  <p className="invalid-password">
                    {errors.hasOwnProperty('_newPassword')
                      ? errors._newPassword[0]
                      : null}
                  </p>
                </FormGroup>

                <FormGroup className="password-input">
                  {<p className={`sub-title ${(confirmPassOnFocus || retypePassword) ? "show" : ""}`}>Confirm New Password</p>}
                  <InputGroup>
                    <input
                      type={confirmPassType}
                      name="_retypePassword"
                      value={retypePassword}
                      onChange={onChangeRetypePassword}
                      placeholder={confirmPassPlaceHolder}
                      onFocus={() => {
                        setConfirmPassOnFocus(true)
                        setConfirmPassPlaceHolder("")
                      }}
                      onBlur={() => {
                        setConfirmPassOnFocus(false)
                        setConfirmPassPlaceHolder("Confirm New Password")
                      }}
                    />
                    <KickImage onClick={() => {
                      setConfirmPassEye(!confirmPassEye)
                    }} src={confirmPassEye ? EyeOpen : EyeClose} />
                  </InputGroup>
                  <p className="invalid-password">
                    {errors.hasOwnProperty('_retypePassword')
                      ? errors._retypePassword[0]
                      : null}
                  </p>
                </FormGroup>
                {props.errorMsg ? <p className='error-message'>{props.errorMsg}</p> : null}

                <Button
                  className={`submit-button ${!newPassword || !retypePassword ? "disabled" : ""}`}
                  onClick={submitChangePassword}
                  disabled={!newPassword || !retypePassword}
                >
                  Submit
                </Button>
              </Form>
              <p onClick={() => props.forgotPassword()} className='forgot-password'>Forgot password?</p>
            </>
        }
      </Modal.Body>
    </Modal>
  );
};

export default ModalChangePasswordV4;
